// An app the loan officer just connected: the web app opens the sidebar on Apps & MCP after the app's
// sign-in sends them back (`connectedApp`, empty when the chat asked for it, and the sign-in's `status`).
const APP_PATTERN = /^[a-z0-9_-]{0,60}$/;
const STATUSES = ["success", "failed"];

/** `{ app, status, at }` from the sidebar's URL or the web app's message, or null when there is none. */
export const readConnectedAppLanding = ({ connectedApp, connectStatus } = {}) => {
  if (typeof connectedApp !== "string" || !APP_PATTERN.test(connectedApp)) {
    return null;
  }

  return { app: connectedApp, status: STATUSES.includes(connectStatus) ? connectStatus : "", at: Date.now() };
};
